import selectTechImage from "../Assets/Projects/select-tech.jpg";
import topVatLieuImage from "../Assets/Projects/top-vat-lieu.jpg";
import salonImage from "../Assets/Projects/salon-turn-manager.jpg";
import nailsRUsImage from "../Assets/Projects/nails-r-us.jpg";
import lakeHomesImage from "../Assets/Projects/lake-homes.jpg";
import ecofitImage from "../Assets/Projects/ecofit.jpg";
import academixImage from "../Assets/Projects/academix.jpg";

export const contactInfo = {
  email: "hunglm410.dev@gmail.com",
  github: "https://github.com/punhe",
  linkedin: "https://www.linkedin.com/in/ronniele/",
  portfolio: "https://punhe.vercel.app/",
};

export const socialLinks = [
  {
    platform: "Email",
    handle: contactInfo.email,
    url: `mailto:${contactInfo.email}`,
  },
  {
    platform: "LinkedIn",
    handle: "in/ronniele",
    url: contactInfo.linkedin,
  },
  {
    platform: "GitHub",
    handle: "@punhe",
    url: contactInfo.github,
  },
  {
    platform: "Facebook",
    handle: "sofv.hung2003",
    url: "https://www.facebook.com/sofv.hung2003",
  },
];

export const heroContent = {
  name: "Lê Mạnh Hùng",
  role: "Websites, automation, and delivery for small businesses",
  title: "More sales, less manual work.",
  lead:
    "I find where a business loses customers or staff time, then ship the website, tool, or automation that fixes it.",
};

/* Proof points under the hero. Every fact comes from a live system or a project document. */
export const heroProof = [
  {
    value: "30 sec",
    lead: "Help customers decide",
    text: "Tile buyers preview a product on a photo of their own room before they visit the store.",
  },
  {
    value: "22 / 22",
    lead: "Get found locally",
    text: "A salon site went from 7 of 22 search and release checks passing to all 22, so Google can read every service page.",
  },
  {
    value: "1,628 SKUs",
    lead: "Give staff time back",
    text: "Stock syncs from accounting software four times a day, so nobody checks it by hand.",
  },
];

export const deliverySteps = [
  {
    step: "Find the money",
    title: "Start with the business, not the features",
    body:
      "Where are customers dropping off? Where does staff time go? I pick the one problem that is worth paying to fix.",
    artifact: "A one-page problem, goal, and the number to watch",
  },
  {
    step: "Scope",
    title: "Agree on the smallest fix",
    body:
      "What we build, what we skip, and how we will know it worked. All written down and approved before any code.",
    artifact: "Scope, spec, acceptance criteria",
  },
  {
    step: "Build",
    title: "Ship fast, check against the goal",
    body:
      "I build with the team and test each release against the business goal, not only against the design.",
    artifact: "Tested release and a release checklist",
  },
  {
    step: "Measure",
    title: "Launch, watch, hand over",
    body:
      "A client demo, a production launch, a check on the number we agreed, and a runbook so the team can run it without me.",
    artifact: "Demo, runbook, results check",
  },
];

export const experienceHighlights = [
  {
    company: "U.S. web agency (remote)",
    role: "Delivery PM and Web Developer",
    period: "Aug 2026 - Present",
    summary:
      "Run delivery on websites for local and lead-generation businesses: turn client feedback into tracked tasks with acceptance criteria, keep work moving, and QA every release before the client sees it.",
    points: [
      "Lead-generation and local sites",
      "Acceptance criteria and QA gates",
      "WordPress, Next.js, Netlify",
    ],
  },
  {
    company: "Freelance",
    role: "Business-focused Delivery Lead and Developer",
    period: "Oct 2025 - Present",
    summary:
      "Help small businesses in the U.S. and Vietnam fix lost sales and manual work: find the problem, scope the fix, build it, demo it, launch it, and hand it over.",
    points: [
      "Retail, salons, real estate, IT services",
      "Scopes, demos, runbooks",
      "Websites, internal tools, automation",
    ],
  },
  {
    company: "Wecare Group",
    role: "Data Engineer",
    period: "Nov 2025 - Present",
    summary:
      "Replace spreadsheet and paper steps for warehouse and sales teams with Power Apps, automated flows, and stock-count reports.",
    points: [
      "4+ Power Apps",
      "10+ Power Automate flows",
      "Power BI stock-count reports",
    ],
  },
  {
    company: "FPT Software",
    role: "Front-End Developer",
    period: "Apr 2024 - Sep 2024",
    summary:
      "Worked in Scrum teams on enterprise projects: moved a WinForms app to Nuxt/Vue and built a hotel management UI in React and TypeScript.",
    points: [
      "WinForms to web migration",
      "30% lower latency",
      "UAT with enterprise clients",
    ],
  },
];

export const quickFacts = [
  "Based in Quy Nhơn, Vietnam. Remote, UTC+7.",
  "Freelance for small businesses in the U.S. and Vietnam since Oct 2025.",
  "Delivery PM at a U.S. web agency since Aug 2026.",
  "BSc Software Engineering, FPT University, 2025.",
];

export const skillGroups = [
  {
    title: "Business",
    items: ["Finding lost sales", "Scoping to a goal", "Local SEO", "Lead-generation pages", "Client demos"],
  },
  {
    title: "Automation",
    items: ["n8n", "Power Platform", "AI in workflows", "Stock and CRM sync"],
  },
  {
    title: "Build",
    items: ["React", "Next.js", "TypeScript", "Laravel", "Supabase", "WordPress"],
  },
  {
    title: "Delivery and QA",
    items: ["Linear", "Notion", "Specs and acceptance criteria", "Playwright", "Docker", "GitHub Actions"],
  },
];

/* Featured case studies, ordered by business impact. */
export const caseStudies = [
  {
    title: "Top Vật Liệu",
    kind: "Building-materials retailer, Vietnam",
    period: "Jul - Sep 2026",
    role: "Solution lead and solo developer",
    problem:
      "Tile buyers hesitate when they cannot picture a product at home. Staff lost time answering stock questions by checking the accounting software by hand.",
    delivery: [
      "Picked two money problems first: helping buyers decide, and freeing staff from stock questions.",
      "Wrote the specs and recorded every place the build changed from the plan.",
      "Kept a handoff note with live systems, open blockers, and a runbook for the owner.",
    ],
    build: [
      "AI room preview: a customer uploads a photo, picks a tile, and sees a render in about 30 seconds.",
      "Stock syncs from MISA about four times a day into a public stock page and API.",
      "A Zalo chatbot and Zalo Mini App so customers check stock where they already chat.",
    ],
    outcome:
      "Live in production. Customers preview tiles on their own room, and live stock for about 1,628 SKUs answers questions without staff.",
    stack: ["Next.js", "Qwen image models", "n8n", "Playwright", "Zalo Mini App"],
    image: topVatLieuImage,
    imageAlt: "Top Vật Liệu AI tile preview landing page with a modern house and pool",
    liveLink: "https://phoicanh.topvatlieu.com",
  },
  {
    title: "Nails R Us",
    kind: "Local nail salon, North Carolina",
    period: "Dec 2025 - Present",
    role: "Search visibility lead and developer",
    problem:
      "A local salon wins new clients from Google searches, but its site rendered only in the browser, so search engines saw thin, empty pages.",
    delivery: [
      "Measured the starting point and wrote a phased plan with traffic targets.",
      "Defined 22 live checks so every release is verified the same way.",
      "Wrote deploy steps the owner can follow safely.",
    ],
    build: [
      "Every service page now ships real HTML that search engines can read.",
      "Local business data, sitemap, and AI-search file (llms.txt).",
      "A small admin panel so the owner updates gallery and promo images without a developer.",
    ],
    outcome:
      "All 22 checks pass, up from 7. The site is now ready for the plan's target of 400 to 700 organic visits a month by month six.",
    stack: ["React 19", "Vite", "JSON-LD", "PHP API"],
    image: nailsRUsImage,
    imageAlt: "Nails R Us social preview image for a nail salon in Morganton, North Carolina",
    liveLink: "https://nailsrusmorganton.com",
  },
  {
    title: "Select Tech Inc.",
    kind: "IT and cybersecurity company, U.S.",
    period: "2025 - 2026",
    role: "Delivery lead and full-stack developer",
    problem:
      "Select Tech serves car dealerships. Nightly security reports arrived as Word files, so no one could spot trends across sites or show clients the value of the service.",
    delivery: [
      "Got written answers to every open question before estimating.",
      "Wrote the spec with 17 acceptance criteria, so done meant the same thing to everyone.",
      "Split the work by day between two developers and ran a scripted client demo.",
    ],
    build: [
      "Word reports become a dashboard with trends and a map of each lot.",
      "PDF exports the team can hand to dealership clients.",
      "The company's marketing site for dealership IT services.",
    ],
    outcome:
      "Reports the client could not use became something they can show their own customers. Spec to client demo in about one week.",
    stack: ["Laravel", "React", "MySQL", "GitHub Actions", "Three.js"],
    image: selectTechImage,
    imageAlt: "Select Tech Inc. marketing site home page for auto dealership IT services",
    liveLink: "https://www.selecttechinc.com/",
  },
  {
    title: "Salon Turn Manager",
    kind: "SaaS product for nail salons",
    period: "Jun 2026",
    role: "Product owner and solo developer",
    problem:
      "When walk-in clients are handed out from memory, technicians argue about fairness and the front desk slows down while clients wait.",
    delivery: [
      "Wrote the product brief, pricing model, and a two-week launch plan.",
      "Kept hour tracking out on purpose, to avoid U.S. contractor-classification risk for owners.",
      "Wrote a demo script and a pre-launch checklist for sales calls.",
    ],
    build: [
      "A fair, weighted turn queue with booking calendar and staff records.",
      "One product serving many salons, each salon's data kept separate.",
      "English and Vietnamese, since many owners and technicians speak both.",
    ],
    outcome:
      "A product ready to sell to salons, from brief to deployed MVP in 10 days. Demo login available on request.",
    stack: ["Next.js", "Supabase", "PostgreSQL RLS", "next-intl", "Playwright"],
    image: salonImage,
    imageAlt: "Salon Turn Manager login screen",
    liveLink: "https://salon.looperslab.com/en/login",
  },
];

export const moreWork = [
  {
    title: "EcoFit",
    period: "Jan - Mar 2025",
    role: "Founder-side developer",
    summary:
      "Secondhand goods store built end to end. Top 9 at a startup pitch, received funding, and made real sales.",
    image: ecofitImage,
    imageAlt: "EcoFit secondhand store home page with a vintage radio",
    liveLink: "https://eco-fit.vercel.app/",
    codeLink: "https://github.com/punhe/EcoFit",
  },
  {
    title: "Lake Homes Realty",
    period: "Oct - Dec 2025",
    role: "Developer and DevOps",
    summary:
      "Real estate site for North Carolina lake communities, with live listing data and a page for each community buyers search for.",
    image: lakeHomesImage,
    imageAlt: "Lake Homes Realty home page with a lakefront log house",
    liveLink: "https://www.nclakeproperty.com/",
  },
  {
    title: "Academix",
    period: "Jun - Aug 2025",
    role: "Back-end developer, team of five",
    summary:
      "Online course marketplace. I built the parts that move money: instructor revenue, withdrawals, and discounts, plus chat and auth.",
    image: academixImage,
    imageAlt: "Academix online course platform home page",
    liveLink: "https://academix.id.vn",
  },
];

export const automationWork = {
  title: "Automation that gives staff time back",
  period: "2026",
  role: "Automation lead",
  summary:
    "Writing a Facebook post for every rental room took staff time every day. Now captions and resized photos are ready every morning; staff only review and post. Four n8n workflows, 26 tests, and a runbook.",
  stack: ["n8n", "Gemini", "Google Sheets", "Google Drive"],
};
